//I stole this from a google search:
//  https://www.thekrazydev.com/how-to-open-a-dropdown-menu-on-hover-in-react/
import React from 'react'
import { Link } from 'react-router-dom'

const NavLinksScheduleDropdown = () => {
	return (
		<>
			<div
				className='dropdown'
				style={{
					position: 'absolute',
					background: 'white',
					marginTop: '0rem',
					cursor: 'pointer',
					height: '3.2rem',
					borderRadius: '2px',
				}}
			>
				<Link
					to='/admin/masterSchedule'
					style={{
						paddingTop: '.1rem',
						paddingBottom: '.1rem',
						color: 'black',
					}}
				>
					FULL SCHEDULE
				</Link>
				<br></br>
				<Link
					to='/admin/masterScheduleWeek'
					style={{
						display: 'block',
						paddingTop: '.1rem',
						paddingBottom: '.1rem',
						color: 'black',
					}}
				>
					THIS WEEK
				</Link>
			</div>
		</>
	)
}

export default NavLinksScheduleDropdown
